'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _MatrixClientPeg = require('../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2019 Tulir Asokan <tulir@maunium.net>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var ReactionPicker = function (_React$Component) {
    (0, _inherits3.default)(ReactionPicker, _React$Component);

    function ReactionPicker(props) {
        (0, _classCallCheck3.default)(this, ReactionPicker);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ReactionPicker.__proto__ || (0, _getPrototypeOf2.default)(ReactionPicker)).call(this, props));

        _this.state = {
            selectedEmojis: new _set2.default((0, _keys2.default)(_this.getReactions()))
        };
        _this.onChoose = _this.onChoose.bind(_this);
        _this.onReactionsChange = _this.onReactionsChange.bind(_this);
        _this.addListeners();
        return _this;
    }

    (0, _createClass3.default)(ReactionPicker, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.reactions !== this.props.reactions) {
                this.addListeners();
                this.onReactionsChange();
            }
        }
    }, {
        key: 'addListeners',
        value: function addListeners() {
            if (this.props.reactions) {
                this.props.reactions.on("Relations.add", this.onReactionsChange);
                this.props.reactions.on("Relations.remove", this.onReactionsChange);
                this.props.reactions.on("Relations.redaction", this.onReactionsChange);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.reactions) {
                this.props.reactions.removeListener("Relations.add", this.onReactionsChange);
                this.props.reactions.removeListener("Relations.remove", this.onReactionsChange);
                this.props.reactions.removeListener("Relations.redaction", this.onReactionsChange);
            }
        }
    }, {
        key: 'getReactions',
        value: function getReactions() {
            if (!this.props.reactions) {
                return {};
            }
            var userId = _MatrixClientPeg2.default.get().getUserId();
            var myAnnotations = this.props.reactions.getAnnotationsBySender()[userId] || [];
            return Object.fromEntries([].concat((0, _toConsumableArray3.default)(myAnnotations)).filter(function (event) {
                return !event.isRedacted();
            }).map(function (event) {
                return [event.getRelation().key, event.getId()];
            }));
        }
    }, {
        key: 'onReactionsChange',
        value: function onReactionsChange() {
            this.setState({
                selectedEmojis: new _set2.default((0, _keys2.default)(this.getReactions()))
            });
        }
    }, {
        key: 'onChoose',
        value: function onChoose(reaction) {
            this.componentWillUnmount();
            this.props.closeMenu();
            this.props.onFinished();
            var myReactions = this.getReactions();
            if (myReactions.hasOwnProperty(reaction)) {
                _MatrixClientPeg2.default.get().redactEvent(this.props.mxEvent.getRoomId(), myReactions[reaction]);
                // Tell the emoji picker not to bump this in the more frequently used list.
                return false;
            } else {
                _MatrixClientPeg2.default.get().sendEvent(this.props.mxEvent.getRoomId(), "m.reaction", {
                    "m.relates_to": {
                        "rel_type": "m.annotation",
                        "event_id": this.props.mxEvent.getId(),
                        "key": reaction
                    }
                });
                return true;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var EmojiPicker = _index2.default.getComponent('emojipicker.EmojiPicker');
            return _react2.default.createElement(EmojiPicker, {
                onChoose: this.onChoose,
                selectedEmojis: this.state.selectedEmojis,
                showQuickReactions: false,
                showHeader: false,
                showPreview: false

            });
        }
    }]);
    return ReactionPicker;
}(_react2.default.Component);

ReactionPicker.propTypes = {
    mxEvent: _propTypes2.default.object.isRequired,
    onFinished: _propTypes2.default.func.isRequired,
    closeMenu: _propTypes2.default.func.isRequired,
    reactions: _propTypes2.default.object
};
exports.default = ReactionPicker;
module.exports = exports['default'];
//# sourceMappingURL=ReactionPicker.js.map